/**
 * One place to ask the person for their password when the key that opens
 * their data isn't in this tab (a new tab, or sessionStorage cleared).
 *
 * `requestUnlock(reason)` resolves with the private key once they've
 * unlocked, or rejects if they chose "Not now". Concurrent asks share one
 * dialog. The dialog itself is <UnlockGate/>, mounted once in App.js; an ask
 * made before it mounts (the very first /auth/me of a new tab carries sealed
 * details) waits for it rather than being dropped. Before any dialog, the
 * other open tabs are asked for the key (lib/keyShare.js).
 */
import { askOtherTabs } from './keyShare';
import { setPrivateKey } from './crypto';

let listener = null;
let pending = null;
let waiting = null;

export const setUnlockListener = (fn) => {
  listener = fn;
  if (fn && waiting) {
    const ask = waiting;
    waiting = null;
    fn(ask);
  }
};

export const requestUnlock = (reason) => {
  if (pending) return pending;
  pending = askOtherTabs().then((key) => {
    if (key) {
      setPrivateKey(key);
      return key;
    }
    return new Promise((resolve, reject) => {
      const ask = { reason, resolve, reject };
      if (listener) listener(ask);
      else waiting = ask;
    });
  }).finally(() => { pending = null; });
  return pending;
};
